<template>
    <div class="form-block">
        <submit-spinner v-show="submitting || success " :is-loading="submitting" :is-success="success"></submit-spinner>
        <form ref="form" :action="action" :method="method" @submit.prevent="onSubmit">
            <slot>
            </slot>
        </form>
    </div>
</template>
<script>
    import axios from 'axios';
    import SubmitSpinner from './submit_spinner';
    export default {
        components: {
            SubmitSpinner,
        },
        name: 'slot-form',

        props: {
            method: {
                type: String,
                required: true
            },
            action: {
                type: String,
                required: true
            }
        },
        data: () => ({
            submitting: false,
            success: false
        }),
        methods: {
            onSubmit(){
                const data = new FormData(this.$refs.form);
                this.submitting = true;
                const method = this.method;
                const action = this.action;
                axios.post(action, data)
                    .then( response => {
                        // this.$toasted.success(response.data.message);
                        console.log(response);
                        this.success = true;
                        this.clearInputs();
                    })
                    .catch(error => {
                        let toaster = this.$toasted;
                        $.each(error.response.data.errors, function(key, value) {
                            toaster.error(value.message);
                        });
                        this.success = false;

                    })
                    .then(()=>{
                        this.submitting = false;
                        setTimeout(()=>{
                            this.success = false;
                        }, 3500);
                    });
            },
            clearInputs(){
                let inputs = document.querySelectorAll(".form-block .form-element");

                $.each(inputs, function(key, value) {
                    if(value.tagName  == 'INPUT' || value.tagName  == 'TEXTAREA'){
                        value.value ="";
                    }else{
                        value.innerHTML="";
                    }
                   
                    
                });
            }
        }
    };
</script>
<style>
    .form-block{
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/SlotForm.vue